import { ShieldCheck, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Support() {
  return (
    <section id="support" data-testid="support-section" className="pb-20 sm:pb-28">
      <div className="section-shell">
        <Reveal>
          <div className="glass-panel rounded-3xl p-8 sm:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative overflow-hidden">
            <div className="pointer-events-none absolute -right-20 -top-20 w-72 h-72 rounded-full bg-sky-500/10 blur-[100px]" />
            <div className="lg:col-span-8">
              <p className="micro-label flex items-center gap-3">
                <ShieldCheck size={15} /> Ongoing Care
              </p>
              <h2 className="mt-4 font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
                Optional monthly support, so nothing slips
              </h2>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-slate-400 max-w-2xl">
                Once you're live, we can look after the ongoing work: website maintenance, content updates,
                SEO health checks and automation support — so you can get on with running your business.
              </p>
            </div>
            <div className="lg:col-span-4 lg:justify-self-end">
              <a href="#contact" data-testid="btn-monthly-support" className="btn-ghost w-full lg:w-auto">
                Ask About Monthly Support <ArrowRight size={15} strokeWidth={2.5} />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
